import React from 'react';
import { Box, Typography } from '@mui/material';
import useTranslate from '../../../Hooks/useTranslate';

//value can be long (branches, products lists): it wraps instead of being truncated
const FilterDetail = function FilterDetail({ label, value = null }) {
  const translate = useTranslate();

  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {translate(label)}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {value}
      </Typography>
    </Box>
  );
};

export default FilterDetail;
